import { apiClient, anonymousClient, API_VERSION } from '@/core/config/api';

/**
 * Point the shared axios clients at the origin the export worker named.
 *
 * The bundle bakes one API origin at build time, which is correct in every
 * browser a person uses. The print page is the one page that runs inside the
 * worker's container, where that origin resolves to the container itself, so
 * the worker passes a reachable one as ?api= and this applies it before any
 * module-level client issues its first request.
 */
export function applyPrintApiOrigin(): void {
  const apiBaseUrl = new URLSearchParams(window.location.search).get('api');
  if (!apiBaseUrl) return;

  const baseURL = `${apiBaseUrl.replace(/\/$/, '')}/api/${API_VERSION}`;
  apiClient.defaults.baseURL = baseURL;
  anonymousClient.defaults.baseURL = baseURL;
}
